
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { ProductProductOption } from './product-product-option-entity';
import { ProductLinkedProduct } from './product-linked-product-entity';
import { ProductCategory } from '../control-tables/product-category-entity';
import { Brand } from '../control-tables/brand';
import { ProductPage } from '../control-tables/product-page';
import { ProductSalesGroup } from '../control-tables/product-sales-group';
import { ProductLogisticGroup } from '../control-tables/product-logistic-group';
import { ProductAnalysisGroup1 } from '../control-tables/product-analysis-group1-entity';
import { ProductAnalysisGroup2 } from '../control-tables/product-analysis-group2-entity';
import { ProductAnalysisGroup3 } from '../control-tables/product-analysis-group3-entity';
import { ProductAnalysisGroup4 } from '../control-tables/product-analysis-group4-entity';
import { ProductAnalysisGroup5 } from '../control-tables/product-analysis-group5-entity';
import { ProductSpareProduct } from './product-spare-product-entity';


export class Product extends BaseEntity {
  
    id                      : number;
    productCode		          : string; 
    name 		                : string;  
    longDescription	  	    : string;  
    brand 		              : Brand;  
    productPage             : ProductPage; 		 
    rank 		                : number;
    salesPrice              : number;
    productSalesGroup       : ProductSalesGroup; 
    productLogisticGroup    : ProductLogisticGroup; 
    productCategoryCde      : string; 
    productCategoryTypeCde	: string; 
    productAnalysisGroup1   : ProductAnalysisGroup1; 
    productAnalysisGroup2   : ProductAnalysisGroup2; 
    productAnalysisGroup3   : ProductAnalysisGroup3; 
    productAnalysisGroup4   : ProductAnalysisGroup4; 
    productAnalysisGroup5   : ProductAnalysisGroup5; 
    hold 		                : boolean;
    holdReason 		          : string;
    purchasePacking         : number; 
    loadPacking             : number;
    salesPacking 		        : number;
    purchasePrice           : number;
    loadable 		            : boolean;
    salable 		            : boolean;
    returnable 		          : boolean;
    expirable 		          : boolean;
    inventoryable 		      : boolean;
    inventoryable2 		      : boolean;
    inventoryable3 		      : boolean;
    presenceCheckable 		  : boolean;
    presenceCheckable2 		  : boolean;
    facingable 		          : boolean;
    apos 		                : boolean;
    bonus 		              : boolean;
    freeGood 		            : boolean;
    slowMoving 		          : boolean;
    virtualProduct 		      : boolean;
    assetProduct 		        : boolean;
    consignmentProduct 		  : boolean;
    loyaltyProduct 		      : boolean;
    promoSequence 		      : number;
    promoRate 		          : number; 
    weight 		              : number; 
    volume 		              : number; 
    facingFactor 		        : number; 
    statUnitRate 		        : number; 
    idealOrderable 		      : boolean;
    idealOrderFactor 		    : number; 
    orderable 		          : boolean;
    colorCode 		          : string; 
    photo 		              : string; 
    decimalPrecision        : number;
    packingProcessId        : number;

    availableQuantity       : number;
    damagedQuantity1        : number;
    damagedQuantity2        : number;

    productCategory    : ProductCategory = new ProductCategory();
   
   // productCategoryType     : ProductCategoryTypeEntity = new ProductCategoryTypeEntity();
    
    productProductOptions : ProductProductOption[];
    productLinkedProducts : ProductLinkedProduct[];
    productSpareProducts  : ProductSpareProduct[];


    // Quatities
    quantityL                : number[] = [];
    quantityP                : number[] = [];
    quantityU                : number[] = [];
    rate                     : number[] = [];
    totalQuantity            : number;

    orderableByUnit          : boolean = false; // TODO : has to be set correctly

    codeName                 : string;
   
    constructor() {
      super();
    }
}
